var _rect, _path, _path2, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGbp = function SvgGbp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5513_108018",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 16,
    height: 12,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5513_108018)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2V14H16V2H0Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5513_108018",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2V14H16V2H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5513_108018)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5513_108018",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 16,
    height: 12,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5513_108018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.78149 13.1427L1.73935 14.6317L16.08 3.61892L17.9371 1.40617L14.1721 0.908497L8.3229 5.65423L3.6149 8.85175L-1.78149 13.1427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.29944 14.1859L0.494269 15.0501L17.2703 1.20059H14.7517L-1.29944 14.1859Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7816 13.1427L14.2608 14.6317L-0.0798473 3.61892L-1.93701 1.40617L1.82802 0.908497L7.67722 5.65423L12.3852 8.85175L17.7816 13.1427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6615 13.8914L15.8678 14.7555L8.72439 8.82587L6.60652 8.16336L-2.11569 1.41376H0.40288L9.1202 8.00315L11.4357 8.79757L17.6615 13.8914Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_5513_108018",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88892 0.999998H6.11114V6H-0.986206V10H6.11114V15H9.88892V10H17.0138V6H9.88892V0.999998Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88892 0.999998H6.11114V6H-0.986206V10H6.11114V15H9.88892V10H17.0138V6H9.88892V0.999998Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11114 0.999998V-1.90735e-06H5.11114V0.999998H6.11114ZM9.88892 0.999998H10.8889V-1.90735e-06H9.88892V0.999998ZM6.11114 6V7H7.11114V6H6.11114ZM-0.986206 6V5H-1.98621V6H-0.986206ZM-0.986206 10H-1.98621V11H-0.986206V10ZM6.11114 10H7.11114V9H6.11114V10ZM6.11114 15H5.11114V16H6.11114V15ZM9.88892 15V16H10.8889V15H9.88892ZM9.88892 10V9H8.88892V10H9.88892ZM17.0138 10V11H18.0138V10H17.0138ZM17.0138 6H18.0138V5H17.0138V6ZM9.88892 6H8.88892V7H9.88892V6ZM6.11114 2H9.88892V-1.90735e-06H6.11114V2ZM7.11114 6V0.999998H5.11114V6H7.11114ZM-0.986206 7H6.11114V5H-0.986206V7ZM0.0137939 10V6H-1.98621V10H0.0137939ZM6.11114 9H-0.986206V11H6.11114V9ZM7.11114 15V10H5.11114V15H7.11114ZM9.88892 14H6.11114V16H9.88892V14ZM8.88892 10V15H10.8889V10H8.88892ZM17.0138 9H9.88892V11H17.0138V9ZM16.0138 6V10H18.0138V6H16.0138ZM9.88892 7H17.0138V5H9.88892V7ZM8.88892 0.999998V6H10.8889V0.999998H8.88892Z",
    fill: "white",
    mask: "url(#path-9-inside-1_5513_108018)"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGbp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "GBP.3259c1cecf403ef625a87fcf26f4c309.svg";